import { FC } from "react";

interface NewsIconSVGProps {
    className?: string;
}

const NewsIconSVG: FC<NewsIconSVGProps> = ({ className }) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" version="1.1">
            <g>
                <path
                    d="M27,5V3H1v26 c0,1.105,0.895,2,2,2h26c1.105,0,2-0.895,2-2V5H27z"
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <rect
                    fill="none"
                    height="8"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    width="10"
                    x="5"
                    y="19"
                />
                <line
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    x1="27"
                    x2="27"
                    y1="5"
                    y2="24"
                />
                <line
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    x1="27"
                    x2="27"
                    y1="26"
                    y2="28"
                />
                <line
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    x1="4"
                    x2="24"
                    y1="11"
                    y2="11"
                />
                <line
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    x1="4"
                    x2="24"
                    y1="7"
                    y2="7"
                />
                <line
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    x1="4"
                    x2="24"
                    y1="15"
                    y2="15"
                />
                <line
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    x1="18"
                    x2="24"
                    y1="19"
                    y2="19"
                />
                <line
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    x1="18"
                    x2="24"
                    y1="23"
                    y2="23"
                />
                <line
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    x1="18"
                    x2="24"
                    y1="27"
                    y2="27"
                />
            </g>
        </svg>
    );
};

export default NewsIconSVG;
